const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {	
			ZZ_YKKTAIWAN1: {
				name: ['(客製)獎金計算', '(客製)獎金計算', '(客製)獎金計算'],
				children: {
					ZZ_YKKTAIWAN_PB10110: {
						name: ['(客製)特殊獎金計算參數', '(客製)特殊獎金計算參數', '(客製)特殊獎金計算參數'],
						url: '/zz_ykktaiwan_pb10110',
						hint: [],
					},					
					ZZ_YKKTAIWAN_PB40210: {
						name: ['(客製)特殊獎金計算', '(客製)特殊獎金計算', '(客製)特殊獎金計算'],
						url: '/zz_ykktaiwan_pb40210',
						hint: [],
					},
				},
			},
			ZZ_YKKTAIWAN2: {
				name: ['(客製)薪資袋', '(客製)薪資袋', '(客製)薪資袋'],
				children: {
					ZZ_YKKTAIWAN_PB10950: {
						name: ['(客製)薪資袋增加等第設定', '(客製)薪資袋增加等第設定', '(客製)薪資袋增加等第設定'],
						url: '/zz_ykktaiwan_pb10950',
						hint: [],
					},
				},
			},
			ZZ_YKKTAIWAN3: {
				name: ['(客製)特殊津貼', '(客製)特殊津貼', '(客製)特殊津貼'],
				children: {
					ZZ_YKKTAIWAN_PB10310: {
						name: ['(客製)特殊津貼參數設定', '(客製)特殊津貼參數設定', '(客製)特殊津貼參數設定'],
						url: '/zz_ykktaiwan_pb10310',
						hint: [],
					},
					ZZ_YKKTAIWAN_PB10410: {
						name: ['(客製)特殊津貼試算作業', '(客製)特殊津貼試算作業', '(客製)特殊津貼試算作業'],
						url: '/zz_ykktaiwan_pb10410',
						hint: [],
					},
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};